import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostPesticideRequirement from '.';
interface IPostPesticideRequirementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostPesticideRequirement = ({
  onSuccess,
}: IPostPesticideRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPesticideRequirementPayload) => {
      return PostPesticideRequirement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostPesticideRequirement};
